import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/my-work',
      name: 'my-work',
      component: () => import(/* webpackChunkName: "my-work" */ './views/MyWork.vue')
    },
    {
      path: '/my-work/:slug',
      name: 'album',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "album" */ './views/Album.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import(/* webpackChunkName: "contact" */ './views/Contact.vue')
    },
    {
      path: '/404',
      name: '404',
      component: () => import(/* webpackChunkName: "404" */ './components/NotFound.vue')
    },
    {
        path: '*', component: () => import(/* webpackChunkName: "404" */ './components/NotFound.vue')
    }
  ]
})
